import { ChangeDetectionStrategy, Component, SimpleChanges } from '@angular/core';


import { CustomizerColorsAutoUpdateComponent, CustomizerComponentHeaderComponent } from '@app/customizer/components';
import { TranslatePipe } from '@ngx-translate/core';
import { BrandModeService } from '@services/brandmode.service';
import { ConfigurationService } from '@services/configuration.service';
import { ComponentVariantFromApiModel } from '@models/api-models/component-variant-fromapi';
import { ComponentVariantModel } from '@models/component-variant';
import { VariantColorModel } from '@models/variant-color';
import { DataApiService } from '@services/data-api.service';
import { EventsService } from '@services/events.service';
import { ComponentVariantChangeModel } from '../../../../_models/component-variant-change';
import { AngleConstants } from '../../../../shared/angle-constants';
import { BaseCustomizerComponent } from '../../../../shared/base-customizer-component';

@Component({
	selector: 'gemstone-color',
	templateUrl: 'gemstone-color.component.html',
	styleUrls: ['./gemstone-color.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [CustomizerColorsAutoUpdateComponent, CustomizerComponentHeaderComponent, TranslatePipe]
})
export class GemstoneColorComponent extends BaseCustomizerComponent {

	public selectableVariants: Array<ComponentVariantFromApiModel> | undefined = [];
	public extendedInformation: boolean = false;

	constructor(
		public override events: EventsService,
		public apiService: DataApiService,
		private brandmodeService: BrandModeService,
		public override configurationService: ConfigurationService
	) {
		super(events, apiService, configurationService);
		this.extendedInformation = this.brandmodeService.isPrecious;
	}

	async initData() {
		this.events.showLoader(true);

		this.selectableVariants = await this.fetchData();

		this.events.showLoader(false);
	}

	onChanges(changes: SimpleChanges): void {
		this.setImageSliderByName(AngleConstants.Perspective);
	}

	async fetchData(): Promise<Array<ComponentVariantFromApiModel> | undefined> {
		const variant = this.getSelectedVariant;

		if (variant) {
			variant.VariantColorViewed = true;
			console.warn('variant', variant);

			let apidata: Array<ComponentVariantFromApiModel> = [];
			if (variant.VariantSize) {
				apidata = await this.configurationService.getVariants(this.configuration?.ModelConfigurationUuid, this.modelGroup, undefined, variant.Uuid, variant.VariantSize.Uuid) ?? [];
			}

			await this.RunDisablingSystem(apidata);
			return apidata;
		}

		return undefined
	}

	onSelect(color: VariantColorModel) {
		this.events.showLoader(true);

		const newVariant = Object.assign(new ComponentVariantModel(this.getSelectedVariant.Discontinued, this.getSelectedVariant.New), this.getSelectedVariant);
		const oldVariant = Object.assign(new ComponentVariantModel(this.getSelectedVariant.Discontinued, this.getSelectedVariant.New), this.getSelectedVariant);
		newVariant.VariantColor = color;
		newVariant.NotSelected = false;
		this.updateVariant(new ComponentVariantChangeModel(oldVariant, newVariant, null));
	}

}
